<template>
	<footer class="page-footer">
		<div class="page-footer__content">
			<div class="container">
				<Logo />

				<Menu className="page-footer__menu" :isFooter="true" />
			</div>
		</div>

		<div class="page-footer__compliance">
			<div class="container">
				<p v-html="$t('footer.compliance')"></p>
			</div>
		</div>
	</footer>
</template>

<script>
import Logo from "@/components/layout/Logo";
import Menu from "@/components/layout/Menu";

export default {
  name: "Footer",
  components: { Logo, Menu }
};
</script>
